//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../no/TaggedObject.js";
import "../Diagramming/Diagramming.RenderingPropertiesBuilder.js";
import "../Diagramming/Diagramming.Tables.CellSettingsBuilder.js";
import "../Diagramming/Diagramming.TextStyleBuilder.js";
import "../no/Diagramming.js";
let d=[[[0,"ConnectionLabelHorizontalOffsetPosition",1,0],[0,"ConnectionLabelOffset",1,0],[0,"ConnectionLabelPositionCenter",1,0],[0,"ConnectionLabelVerticalOffsetPosition",1,0],[1,"TablesBorderCellSettings",0,"Diagramming.RenderingPropertiesBuilder",0],[1,"TablesCellSettings",0,"Diagramming.Tables.CellSettingsBuilder",0],[1,"TextStyleConnectionBuilder",0,"Diagramming.TextStyleBuilder",0],[1,"TextStyleNoteBuilder",0,"Diagramming.TextStyleBuilder",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.PID.PreferencesAnnotationBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.PreferencesAnnotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;